import React, { useEffect, useMemo, useState } from "react";
import Form from "components/molecules/Form/Form";
import { useForm } from "components/molecules/Form";
import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import { NewRoleWrap } from "components/atoms/Customers/ManageRole/AddNewRole/AddNewRole.styles";
import { FaArrowRightLong } from "react-icons/fa6";
import ModalContainer from "components/molecules/ModalContainer";
import DataTabs from "components/molecules/DataTabs";
import adminService from "services/adminService";
import Toast from "components/molecules/Toast";
import { useAuthContext } from "Context/authContext";
import PermissionSelector from "components/atoms/Customers/ManageRole/PermissionSelector";


const AddNewRole = ({ role, onSubmit, data, businessId }) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  const { refetch } = useAuthContext();

  const [state, setState] = useState({});

  const permissions = useMemo(
    () => role?.permissions?.map(({ _id }) => _id) ?? [],
    [role]
  );

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      if (data) {
        await adminService.updateRole(role?._id, {
          type: e?.role_type,
          description: e?.role_description,
          permissions: state?.permissions,
        });
      } else {
        await adminService.createRole({
          type: e?.role_type,
          description: e?.role_description,
          permissions: state?.permissions,
          businessId,
        });
      }
      refetch();
      setLoading(false);
      Toast({
        type: "success",
        message: "Role saved successfully",
      });
    } catch (error) {
      setLoading(false);
      Toast({
        type: "error",
        message: error.message,
      });
    }
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        role_type: data?.type,
        role_description: data?.description,
      });
    }
  }, [data]);

  useEffect(() => {
    if (role) {
      form.setFieldsValue({
        role_type: role?.type,
        description: role?.description,
      });
      setState({
        role_type: role?.type,
        role_description: role?.description,
        permissions,
      });
    }
  }, [role]);
  return (
    <>
      <NewRoleWrap>
        <Form
          form={form}
          onSubmit={handleSubmit}
          onTouched={(_) => setState((__) => ({ ...__, ..._ }))}
        >
          <div className="user-fields">
            <Form.Item
              type="text"
              name="role_type"
              sm
              rounded
              placeholder="Enter Type"
              label="Type"
              rules={[
                { required: true, message: "Please enter role" },
                {
                  pattern: /^[A-Z_]+$/,
                  message:
                    "Role type must be uppercase and only alphabets and _ are allowed",
                },
              ]}
            >
              <Field maxLength={40} />
            </Form.Item>
            <Form.Item
              type="text"
              name="role_description"
              sm
              rounded
              placeholder="Enter Description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Description is Required",
                },
              ]}
            >
              <Field maxLength={40} />
            </Form.Item>
          </div>
          {/* <ModalContainer
            title="Customize Permissions"
            width="1000"
            btnComponent={({ onClick }) => (
              <div className="permissions" onClick={onClick}>
                <span>Customize Permissions</span>
                <FaArrowRightLong />
              </div>
            )}
            content={({ onClose }) => <DataTabs data={rolesData} />}
          /> */}
          <PermissionSelector
            permissions={permissions}
            forRoles
            onDone={(__) => setState((_) => ({ ..._, permissions: __ }))}
          />

          <div className="btn-holder">
            <Button
              lg
              type="submit"
              loader={loading}
              disabled={!state?.permissions?.length}
            >
              Save Changes!
            </Button>
          </div>
        </Form>
      </NewRoleWrap>
    </>
  );
};

export default AddNewRole;
